module.exports = __webpack_public_path__ + "img/depth.2ab14ee8.svg";